import { useState } from "react";
import { Slider } from "@/components/ui/slider";
import { Button } from "@/components/ui/button";

export default function ProgressSlider({ value, onUpdate, disabled = false }) {
  const [localValue, setLocalValue] = useState(value || 0);
  const [hasChanged, setHasChanged] = useState(false);

  const handleChange = (newValue) => {
    setLocalValue(newValue[0]);
    setHasChanged(newValue[0] !== value);
  };

  const handleUpdate = () => {
    onUpdate(localValue);
    setHasChanged(false);
  };

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <span className="text-sm font-medium text-black">Recording Progress</span>
        <span className="text-lg font-bold text-purple-600">{localValue}%</span>
      </div>

      <div className="relative">
        <div className="h-3 bg-slate-200 rounded-full overflow-hidden">
          <div
            className="h-full bg-gradient-to-r from-pink-500 via-purple-500 to-blue-500 transition-all duration-300"
            style={{ width: `${localValue}%` }}
          />
        </div>
        <Slider
          value={[localValue]}
          onValueChange={handleChange}
          max={100}
          step={1}
          disabled={disabled}
          className="absolute inset-0 opacity-0 cursor-pointer"
          data-testid="progress-slider"
        />
      </div>

      {hasChanged && (
        <Button
          onClick={handleUpdate}
          className="w-full bg-gradient-to-r from-pink-500 via-purple-500 to-blue-500"
          data-testid="update-progress-btn"
        >
          Update Progress
        </Button>
      )}
    </div>
  );
}
